var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-email',{ref:"dialogEmail",attrs:{"isLoading":_vm.isLoading,"contentKey":_vm.contentKey,"contentMap":_vm.contentMap,"data":_vm.emailData},on:{"on-submit-email":_vm.onSubmitEmail}})}
var staticRenderFns = []

export { render, staticRenderFns }